import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentPage } from "~/components/legal/LegalDocumentPage";

export const Route = createFileRoute("/(public)/terms")({
  component: () => <LegalDocumentPage type="terms" title="Algemene voorwaarden" />,
});
